import { colors } from "src/themes";

/**
 * Named color constants kept for backwards compatibility.
 * The values are sourced from the MUI theme (src/themes) so the theme
 * remains the single source of truth. Prefer consuming theme.palette.*
 * directly in new code.
 */
const color = {
  CASCARA: colors.utility.cascara,
  WHITE: colors.utility.white,
  MANTIS: colors.utility.mantis,
  MANGO: colors.utility.mango,
  PAPER_WHITE: colors.utility.paperWhite,
  POBLANO: colors.utility.poblano,
  NYANZA: colors.utility.nyanza,
  WEATHERED_STONE: colors.utility.weatheredStone,
  MIDNIGHT: colors.utility.overlay,
  LIGHT_YELLOW: colors.utility.lightYellow,
  BLACK: colors.utility.black,
  GRAY: colors.utility.grey,
  HOMEOPATHIC_LILAC: colors.utility.homeopathicLilac,
  LAGUNA: colors.utility.laguna
};

export default color;
